import React from 'react';

function MisionVision() {
  return (

    <div className='container mx-auto py-4'>

      <div className='m-auto items-center justify-center mx-5 my-6'>
        <h1 className='text-2xl font-bold font-times text-center'>Visi&oacute;n</h1>
        <p className='text-xl text-justify font-times'>
          Nuestra visión es inspirar a personas, emprendedores y empresarios a <strong>despertar su poder interior</strong>, expandir su mentalidad y vivir con mayor conciencia, propósito y liderazgo.
          Aspiramos a construir una comunidad de <strong>líderes conscientes</strong> que comprendan que el verdadero cambio comienza dentro de cada persona. Cuando una mente despierta, cambian las decisiones, cambian los resultados y cambia el impacto que generamos en el mundo.
          Porque cuando una persona transforma su interior, puede transformar su vida, su empresa y su entorno.

        </p>
      </div>

      <div className='m-auto items-center justify-center mx-5 my-6'>
        <h1 className='text-xl font-bold font-times text-center'>Misi&oacute;n</h1>
        <p className=' text-xl text-justify font-times'>
          Mi misión es ayudar a las personas a despertar su verdadero potencial y comprender que dentro de ellas existe un poder capaz de transformar su vida.
          Vivimos en un mundo donde muchas personas han olvidado quiénes son realmente. Han sido programadas por el miedo, las creencias limitantes y las circunstancias.
          Por eso mi propósito es compartir herramientas de crecimiento personal, mentalidad y conciencia que permitan a cada persona recuperar su poder interior, elevar su forma de pensar y construir una vida con mayor propósito, claridad y libertad.
          Porque cuando una persona cambia su mente…
          su vida comienza a cambiar.

        </p>
      </div>

      <div className='m-auto items-center justify-center mx-5 my-6 '>
        <h1 className='text-center font-bold font-times text-2xl'>Mi Objetivo</h1>
        <p className='text-xl text-justify font-times'>
          Nuestro objetivo es acompañar a las personas en un proceso de crecimiento y transformación a través del <strong>Método Despertar Interior</strong>, ayudándolas a fortalecer su mentalidad, desarrollar mayor conciencia y tomar acciones que generen resultados reales.
          Buscamos brindar herramientas de crecimiento personal, liderazgo y expansión mental que permitan a cada persona:
        </p>
        <ul className='my-6'>
          <li className='text-base md:text-xl font-times md:text-left  text-justify'>•	descubrir su potencial </li>
          <li className='text-base md:text-xl font-times md:text-left  text-justify'>•	romper creencias limitantes </li>
          <li className='text-base md:text-xl font-times md:text-left  text-justify'>•	tomar decisiones con claridad </li>
          <li className='text-base md:text-xl font-times md:text-left  text-justify'>•	y construir una vida y proyectos con propósito. </li>
        </ul>
      </div>

      <div className='m-auto items-center justify-center mx-5 my-5'>
        <h1 className='text-center font-bold font-times text-2xl mb-6'>Valores</h1>
        <div className='flex flex-col mx-5 my-12'>
          <p className='text-base md:text-xl font-times text-center md:text-left  '>
            Los valores que guían este movimiento de transformación son:
          </p>
          <div className='grid grid-cols-1 md:grid-cols-3 md:mx-5 gap-5 md:my-10 my-5'>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5  p-2w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Conciencia</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left'>Creemos que el verdadero cambio comienza cuando una persona despierta y toma conciencia de su poder interior.</p>
            </div>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5 p-2 w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Crecimiento</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left '>La vida es un proceso constante de aprendizaje, evolución y mejora.</p>
            </div>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5 p-2 w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Liderazgo</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left '>Cada persona tiene la capacidad de convertirse en líder de su propia vida y de influir positivamente en su entorno.</p>
            </div>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5 p-2 w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Integridad</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left '>Actuar con coherencia entre lo que pensamos, lo que decimos y lo que hacemos.</p>
            </div>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5 p-2 w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Responsabilidad personal</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left '>Reconocemos que cada persona es responsable de sus decisiones, su crecimiento y su destino.</p>
            </div>

            <div className='flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 md:p-5 my-5 p-2 w-full rounded-md'>
              <h2 className='text-xl md:text-2xl text-center md:text-left font-times'>Impacto positivo</h2>
              <p className='text-base md:text-xl font-times text-center md:text-left '>Buscamos que cada transformación personal se convierta también en una transformación para la familia, la empresa y la sociedad.</p>
            </div>

          </div>

        </div>
        <div className='flex flex-col mx-5 my-12'>
          <h1 className='text-justify text-base md:text-xl font-times md:text-left  font-bold'>Cuando Despiertas Tu Poder Interior, Comienzas A Transformar Tu Vida Y Tu Realidad. </h1>
        </div>
      </div>


    </div>
  );
}

export default MisionVision;